import { MAP_TYPES } from '@deck.gl/carto';
 
const TSN_HISTORICAL_INTERSECTION_SOURCE_ID = 'tsnHistoricalIntersectionSource';
 
const source = {
  id: TSN_HISTORICAL_INTERSECTION_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'cartointegration',
  data: 'tsn_historical_intersection',
};
 
export default source;
 